export const BuildInfo = {timestamp:1772246478000}
